export enum FileRequiredTypes {
  StudentStatus = 'estados_del_alumno',
  JustificationsForAssistance = 'justificativos_para_asistencia',
  ProofOtherEnrollment = 'comprobante_de_otra_matricula',
  RegistrationContract = 'contrato_de_matricula',
  Certificates = 'certificados',
  HelpFiles = 'archivos_de_ayuda',
  AnswerHelpFiles = 'respuesta_para_archivos_de_ayuda',
  ClosingMinutes = 'actas_de_cierre',
  AcademicCalendar = 'calendario_academico',
  TeacherEducationalBackground = 'antecedentes_educacionales_del_docente',
  teacherEmploymentBackground = 'antecedentes_laborales_del_docente',
  teacherAdditionalDocument = 'documentos_adicionales_del_docente',
  courseSyllabus = 'programas_de_asignaturas',
  sectionLearningResult = 'evidencias_resultados_de_aprendizaje',
  PaymentVoucher = 'comprobante_de_pago',
  courseEnrollmentValidation = 'validacion_de_asignatura',
  studentExternalStudiesDocuments = 'documentos_estudios_externos_del_alumno',
  StudentDocument = 'estudiante_documentos',
}

export type SecureResponseFile = {
  id: number;
  name: string;
  extension: string;
  url: string;
};
